/**
 * Takes the value out of a `Result`, throwing its error.
 *
 * For a boundary where throw-based code calls something that returns a
 * `Result` and has no `Result` of its own to return. Without it, `await
 * someResultAsync()` in statement position type-checks and the failure is
 * discarded in silence — `no-floating-promises` only sees an *unawaited*
 * thenable, so an awaited-and-dropped `Result` passes lint.
 *
 * Where the caller does return a `Result`, chain instead: this exits the
 * monad, and exiting it early throws away the reason the type exists.
 */
export const unwrapOrThrow = (result) => result.match((value) => value, (error) => {
    throw error;
});
//# sourceMappingURL=unwrap.js.map